import type { Component } from 'solid-js'
import './auth-cinema.css'

export const AuthBackdrop: Component<{ tone: 'primary' | 'secondary' }> = (props) => {
  return (
    <div class="ac-backdrop" data-ac-bg aria-hidden="true">
      <div class="ac-orb ac-orb-primary" style={{ opacity: props.tone === 'primary' ? 1 : 0 }} />
      <div
        class="ac-orb ac-orb-secondary"
        style={{ opacity: props.tone === 'secondary' ? 1 : 0 }}
      />
      <div class="ac-ring" />
      <div class="ac-dots" />
    </div>
  )
}
